import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './custom-table.css';

const CustomTable = ({listColumns, records, header}) => {
    return (
        <div className="datatable-templating-demo datatable-responsive-demo">
            <div className="card">
                <DataTable scrollable  value={records} header={ header } className="p-datatable-sm">
                    {listColumns.map(items=>{
                        return <Column headerStyle={ items.headerStyle } field={ items.field } header={ items.header }></Column>
                    })}
                </DataTable>
            </div>
        </div>
    );
}

export default CustomTable 
